<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="row">
      <div class="col-md-12" align="right">
        <router-link to="/create_post">
          <base-button type="primary">New Post</base-button>
        </router-link>
      </div>
      <div class="col-md-12 mt-4">
        <news-feed-table />
      </div>
    </div>
  </div>
</template>
<script>
import NewsFeedTable from '@/views/NewsFeed/NewsFeedTable'
export default {
  components: { NewsFeedTable }
}
</script>
